export const DiagramLayers = ['topology', 'quality', 'quota', 'cac'];

export const DiagramConstants = {
  COLORS: {
    red: '#d82028',
    grey: '#525352',
    blue: '#34b3e7',
    orange: '#faa21e',
    darkRed: '#C27708',
    darkGrey: '#099E09',
    darkBlue: '#145C9C',
    darkOrange: '#C27708',
    black: '#000000',
    purple : '#DB7BFF'
  },

  CONNECTION_WIDTH_TYPES: {
    thin: 0.5,
    regular: 1,
    thick: 3,
    extraThick: 6
  },

  DASH_TYPES: {
    solid: false,
    dash: [6, 6]
  }
};
